
  import ArticleDetails from '@/components/ArticleDetails';
  import Events from '@/events/Events';
  import jobsSearchUrlHelper from '@/helper/jobsSearchUrlHelper';
  import LazyHydrate from 'vue-lazy-hydration';

  export default {
    name: 'SectionArticleDetails',
    components: {
      LazyHydrate,
      ArticleDetails,
      RelatedArticles: () => import('@/components/RelatedArticles'),
      TeaseredArticles: () => import('@/components/TeaseredArticles'),
      ShareElement: () => import('@/components/ShareElement'),
      JobAlert: () => import('@/components/JobAlert'),
    },
    props: {
      section: {
        type: Object,
        required: true,
        default: () => {},
      },
    },
    data() {
      return {
        metaData: {},
        seoContentConfig: {},
        article: {},
      };
    },
    async fetch() {
      this.$emitWithClientData(Events.ArticleDetailsViewed, {
        articleId: this.article.id,
      });
    },
    created() {
      this.article = this.section.article;
    },
    methods: {
      jobsSearchUrl() {
        return jobsSearchUrlHelper(
          this.article.filterParams,
          this.$auth.loggedIn,
          this.$auth.user?.candidateProfile?.addresses[0]
        );
      },
    },
  };
